<template>
  <el-row>
    <el-col :span="12">
      <!-- <el-button @click="handleExport" type="primary" size="medium">导出</el-button>
      <el-button @click="handleImport" type="primary" size="medium">导入</el-button>
      <el-button @click="handleSearch" size="medium">搜索</el-button>
      <el-button @click="clearSearch" size="medium">重置</el-button>-->
      <el-button v-for="item in list" :key="item.index" @click="handleClick(item.handler)" v-bind="item.props">{{item.name}}</el-button>
      <slot>
        <!-- <span>action-line 的 slot</span> -->
      </slot>
    </el-col>
  </el-row>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
      default: function () {
        return [
          { name: "搜索", index: 1, handler: "handleSearch" },
          { name: "重置", index: 2, handler: "clearSearch" },
        ];
      },
    },
  },
  methods: {
    handleClick(handler) {
      this.$emit("action-line", handler);
    },
  },
};
</script>

<style>
</style>


// WEBPACK FOOTER //
// src/base/action-line/index.vue